<template>
  <div class="page">
    <div class="box">
      <!--      <div class="banner">-->
      <!--        <div class="iaas_left">-->
      <!--          <div class="title">新闻动态</div>-->
      <!--          <div class="text">软硬一体国产安全可控区块链基础平台</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="banner">
        <div class="iaas_left">
          <div class="title">新闻动态&emsp;</div>
          <div class="text"><span>国产自主可控区块链技术领军者</span></div>
          <div class="btnBox" style="text-align: right">
            <el-button class="btn" @click="goabout()">联系我们</el-button>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">{{ detailData.title }}</div>
        <div class="time">
          <div class="time-img">
            <img src="../../assets/news/logo.png" alt="" />
            <span class="time-digital">兆物信链</span>
            &nbsp;
            <img src="../../assets/news/baas_01.png" alt="" />
            <span class="time-digital">{{ date }}</span>
          </div>
        </div>
        <div
          style="
            border: 1px solid #eeeeee;
            position: relative;
            bottom: 30px;
            width: 100%;
          "
        ></div>
        <div class="ql-container ql-snow">
          <div class="ql-editor" v-html="detailData.content"></div>
        </div>
      </div>
      <div class="content_img">
        <div class="img">
          <img src="../../assets/news/newsF.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "news_details-app",
  data() {
    return {
      detailData: "",
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    date() {
      return this.$route.query.date;
    },
  },
  created() {
    this._getDetails();
  },
  methods: {
    goabout() {
      this.$router.push({
        name: "index-app",
      });
    },
    /*https://article.trilliontrust.com/publish-article/app/article/zhaowuinfo*/

    _getDetails() {
      axios
        .post(
          "https://article.trilliontrust.com/publish-article/app/article/zhaowuinfo",
          {
            id: this.id,
          }
        )
        .then(({ data }) => {
          this.detailData = data.article;
          document.title = data.article.title;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../css/news_mobile";
  /deep/.ql-align-center{
    text-align: center;
  }
  /deep/ .ql-editor img{
    width: 100%;
  }
.banner {
  background-image: url("../../assets/news/beijing.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 260px;
  color: #fff;
  display: flex;
  align-items: center;
  text-align: right;

  .iaas_left {
    margin-left: 8%;
    margin-top: 13%;

    .title {
      display: flex;
      font-size: 22px;
      margin-top: 30px;
      color: #282b31;
    }

    .text {
      font-size: 14px;
      color: #282b31;
      margin-top: 20px;
      margin-left: 30px;
    }

    .btnBox {
      // margin-right: 110px;
      margin-top: 30px;
      margin-bottom: 10px;

      .btn {
        width: 120px;
        height: 39px;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 14px;
        background: #0069fd;
        border-radius: 20px;
      }
    }
  }
}
</style>
